(function(window, angular, undefined) {
    angular.module('formApp')
        .filter("textReplace", function() { // register new filter

            var replacementRegex = /(%%.*?%%)/g,
                cleanRegex = /%%/g;

            return function(input, replacementText) { // filter arguments
                if (typeof replacementText !== 'undefined') {
                    return input.replace(replacementRegex, replacementText); // replace with text
                } else {
                    return input.replace(cleanRegex, ''); // remove %%
                }
                

            };
        });
})(window, window.angular);